<template>
  <div class="min-h-screen relative">
    <slot></slot>
  </div>
</template>
